import React from 'react';

export default function StatCard({ label, value, sub, trend, icon }) {
  return (
    <div className="stat-card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
        <div className="stat-label">{label}</div>
        <div className="stat-icon-wrap">{icon}</div>
      </div>
      <div className="stat-value">{value}</div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div className="stat-sub">{sub}</div>
        <div className="stat-trend">{trend}</div>
      </div>
    </div>
  );
}
